<template>
  <div class="page page-questionnaire">
    <div
      class="page-title page-title_left"
      v-if="item"
      @click="selectQuestionnaire(null)">
      {{item.title}}

      <i class="fas fa-chevron-up"></i>
    </div>
    <div v-else class="page-title">Анкеты</div>

    <div
      v-if="showSubmittedMsg && questionnaireId === null"
      class="flash flash_success">
      <strong>Анкета отправлена.</strong>
    </div>

    <div v-if="!loaded" class="loader mb-5"></div>

    <div class="alert alert-danger"
         role="alert"
         v-if="error">
      {{error}}
    </div>

    <QuestionnaireItem
      v-if="item"
      :questionnaire="item"
      :user="user"
      v-on:submit-questionnaire="submitQuestionnaire" />
    <QuestionnaireList
      v-else-if="loaded"
      :questionnaires="list"
      v-on:select-questionnaire="selectQuestionnaire"/>
  </div>
</template>

<script>
  import QuestionnaireItem from './questionnaire/Item';
  import QuestionnaireList from './questionnaire/List';

  export default {
    name: 'Questionnaire',

    components: {QuestionnaireList, QuestionnaireItem},

    data() {
      return {
        loaded: false,
        showSubmittedMsg: false,
        error: '',
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      questionnaireId() {
        return this.$store.state.questionnaire.questionnaireId;
      },

      user() {
        return this.$store.state.profile;
      },

      item() {
        return this.questionnaires.find(
          questionnaire => this.questionnaireId === questionnaire.id
        );
      },

      list() {
        return this.questionnaires;
      },

      questionnaires() {
        return this.$store.getters.getQuestionnaires;
      },
    },

    methods: {
      async loadData() {
        this.loaded = false;
        this.error = '';

        try {
          await this.$store.dispatch('QUESTIONNAIRE_LOAD_QUESTIONNAIRES');
        } catch(e) {
          this.error = 'Произошла ошибка. Повторите попытку позже.';
        }

        this.loaded = true;
      },

      selectQuestionnaire(id) {
        this.$store.state.questionnaire.questionnaireId = id;

        this.showSubmittedMsg = false;
      },

      async submitQuestionnaire(data) {
        await this.$store.dispatch('QUESTIONNAIRE_SUBMIT_ANSWERS', data);

        this.$store.state.questionnaire.questionnaireId = null;

        this.showSubmittedMsg = true;

        this.loadData();
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page.page-questionnaire {
    padding-top: 50px;

    .page-title {
      position: relative;
      margin: 0;
      padding: 20px 20px;

      &.page-title_left {
        text-align: left;
      }

      i {
        position: absolute;
        top: 20px;
        right: 15px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: $primary;
      }
    }
  }
</style>
